<div *transloco="let tr; prefix: 'profile'; scope: 'profile'">
  <nz-card class="profile-card">
    <ng-container *ngIf="!isEdit && !passwordChange">
      <div class="card-edit">
        <a (click)="editProfile()"><i nz-icon nzType="edit" [nz-tooltip]="'action.edit' | transloco"></i></a>
        <a (click)="editPassword()"><i nz-icon nzType="lock" nzTheme="outline" [nz-tooltip]="tr('action.editPassword')"></i></a>
      </div>
      <div class="profile-main">
        <nz-avatar [nzSize]="80" [nzSrc]="avatarUrl" nzIcon="user"></nz-avatar>

        <div class="profile__fullname">
          {{user.fullname}} <i *ngIf="signExists" [nz-tooltip]="tr('sign.exists.tooltip')" nz-icon nzType="check-circle" [nzTheme]="'twotone'"
                               [nzTwotoneColor]="'#52c41a'"></i>
        </div>
        <div class="profile__phone"><i nz-icon nzType="phone" nzTheme="outline"></i> {{user.phone}}</div>
      </div>

      <nz-divider [nzDashed]="true"></nz-divider>

      <div class="profile-info">
        <div *ngIf="user.iin" nz-row [nzGutter]="8" class="profile__iin">
          <div nz-col [nzXs]="9">{{tr('form.iin')}}:</div>
          <div nz-col>{{user.iin}}</div>
        </div>

        <div *ngIf="user.birthdate" nz-row [nzGutter]="8" class="profile__birthdate">
          <div nz-col [nzXs]="9">{{tr('form.birthdate')}}:</div>
          <div nz-col>{{user.birthdate | date: 'dd MMMM yyyy'}}</div>
        </div>

        <div *ngIf="user.position" nz-row [nzGutter]="8" class="profile__position">
          <div nz-col [nzXs]="9">{{tr('form.position')}}:</div>
          <div nz-col>{{user.position}}</div>
        </div>

        <div *ngIf="user.email" nz-row [nzGutter]="8" class="profile__email">
          <div nz-col [nzXs]="9">{{tr('form.email')}}:</div>
          <div nz-col>{{user.email}}</div>
        </div>

        <div *ngIf="user.address" nz-row [nzGutter]="8" class="profile__address">
          <div nz-col [nzXs]="9">{{tr('form.address')}}:</div>
          <div nz-col>{{user.address}}</div>
        </div>

        <div *ngIf="user.maritalStatus" nz-row [nzGutter]="8" class="profile__marital-status">
          <div nz-col [nzXs]="9">{{tr('form.maritalStatus')}}:</div>
          <div nz-col>{{'hx.enum.MaritalStatus.' + user.maritalStatus | transloco}}</div>
        </div>
      </div>
    </ng-container>
    <app-profile-edit *ngIf="isEdit" [user]="user" (save)="onProfileSaved()" (back)="onBackClicked()"></app-profile-edit>
    <app-password-change *ngIf="passwordChange" [user]="user" (passwordChange)="onPasswordChanged()" (back)="onBackClicked()"></app-password-change>
  </nz-card>

  <div [hidden]="isEdit || passwordChange">
    <nz-divider [nzDashed]="true" [nzText]="tr('components')" nzOrientation="left"></nz-divider>

    <div class="role-table-container">
      <nz-table [nzSimple]="true" [nzData]="matrix" #listTable [nzFrontPagination]="false" nzBordered nzSize="small">
        <thead>
        <tr>
          <th></th>
          <th *ngFor="let cmp of components" nzWidth="55px" class="role-header">
            <span>{{'hx.enum.ComponentType.' + cmp | transloco}}</span>
          </th>
        </tr>
        </thead>
        <tbody>
          <tr *ngFor="let si of listTable.data">
            <td class="store-title">{{ si.group.title | uiLabel }}</td>
            <td [nzAlign]="'center'" *ngFor="let cmp of components">
              <i *ngIf="si.componentMap.get(cmp)" nz-icon [nzType]="'check-circle'" [nzTheme]="'twotone'"
                 [nzTwotoneColor]="'#52c41a'"></i>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
